import { Button, Space, Tree } from 'antd';
import { DeleteFilled } from '@ant-design/icons';
import { useContext } from 'react';
import CTX from '../../lib/AssignmentsContext';
import ModuleEngineIcon from '../images/ModuleEngineIcon';
import styles from './TasksList.module.scss';
const TasksTree = ({
  editable = false,
  assignmentIndex
}) => {
  const {
    data,
    actions
  } = useContext(CTX);
  if (!data.assignments.at(assignmentIndex)) {
    return null;
  }
  const assignment = data.assignments.at(assignmentIndex).data;
  const treeData = assignment.tasks.map(({
    name,
    previewURL,
    contentID
  }, index) => ({
    checkable: false,
    selectable: false,
    key: index,
    title: <Space size={24}>
        {contentID && <ModuleEngineIcon type={contentID.split(':')[0]} width={40} height={30} />}
        {name}
        {editable && <Button danger type="link" icon={<DeleteFilled />} onClick={() => {
        assignment.tasks = assignment.tasks.filter((e, i) => i !== index);
        assignment.instructions = assignment.instructions.filter((e, i) => i !== index);
      }} />}
      </Space>
  }));
  const reorder = ({
    dropPosition,
    dragNode
  }) => {
    const dragIndex = Number(dragNode.key);
    if (dropPosition === dragIndex) {
      return;
    }
    const dropIndex = Math.max(0, dropPosition < dragIndex ? dropPosition : dropPosition - 1);
    let moved = assignment.tasks[dragIndex];
    let tmpArray = assignment.tasks.filter((_, i) => i !== dragIndex);
    tmpArray.splice(dropIndex, 0, moved);
    assignment.tasks = tmpArray;
    moved = assignment.instructions[dragIndex];
    tmpArray = assignment.instructions.filter((_, i) => i !== dragIndex);
    tmpArray.splice(dropIndex, 0, moved);
    assignment.instructions = tmpArray;
  };
  return <>
      <h4>Confirm assigned tasks: </h4>
      <Tree treeData={treeData} rootClassName={styles["activity-tree-list"]} blockNode selectable={false} checkable={false} draggable={editable} onDrop={reorder} allowDrop={({
      dropNode,
      dropPosition
    }) => dropPosition !== 0} data-sentry-element="Tree" data-sentry-source-file="TasksList.jsx" />
    </>;
};
export default TasksTree;